/**
 * Skeleton shown while a pad fetches (spec.md § Editor / Initial load): faint
 * title + body line outlines, not a spinner. Used by the `/p/:slug` route
 * during load and by `/` while it mints a new pad.
 *
 * Marked `aria-hidden` + `aria-busy` so assistive tech announces a loading
 * state rather than reading placeholder bars.
 */

export function PadSkeleton(): React.JSX.Element {
  return (
    <div
      aria-busy="true"
      aria-label="Loading pad"
      className="mx-auto w-full max-w-[720px] px-6 pt-16"
    >
      <div
        aria-hidden="true"
        className="mb-10 h-8 w-2/3 rounded-md bg-sunken motion-safe:animate-pulse"
      />
      <div className="space-y-4" aria-hidden="true">
        <div className="h-4 w-full rounded bg-sunken motion-safe:animate-pulse" />
        <div className="h-4 w-11/12 rounded bg-sunken motion-safe:animate-pulse" />
        <div className="h-4 w-4/5 rounded bg-sunken motion-safe:animate-pulse" />
        <div className="h-4 w-5/6 rounded bg-sunken motion-safe:animate-pulse" />
      </div>
    </div>
  );
}
